<template>
  <template v-for="item in menu" :key="item.label" >
    <span v-if="!(item.child && item.child.length)" class="w-flex"  :class="isChild ? 'menu-is-child' : ''" >
      <template v-if="item.remove == 'no'">
      <w-divider v-if="item.istitle === '1'" class="grow mx2 mt4 menu-section-header text-bold text-upper" color="indigo-light2">{{ item.label }}</w-divider>
      <inertia-link  v-else preserve-scroll preserve-state
        :href="item.disabled ? '' : item.route" 
        class="w-button white w-button--text py4 grow menu-item"
        :class="{ 'indigo-dark2--bg menu-active': $page.url.startsWith(item.route), 'menu-is-child size--xs': isChild, 'size--md mt1': !isChild}"
      >
      {{item.label}} 
        <div class="spacer"></div>
        <w-icon>{{item.icon}}</w-icon>
      </inertia-link>
      </template>
    </span>

    <template v-else-if="item.remove == 'no'">
      <span class="w-flex menu-has-child" :class="isChild ? 'menu-is-child-has-child' : ''" >
        <a href="#" 
          class="w-button white w-button--text size--md py4 mt1 grow menu-item"
          @click="expand(item)"
        >
          {{ item.label }} 
          <div class="spacer"></div>
          <w-icon :class="item.isVisible ? 'menu-collapsed' : 'menu-expanded'" >{{ iconExpand }}</w-icon>
        </a>
      </span>
      <w-transition-slide-fade>
        <div class="w-flex column" v-if="item.isVisible">
          <z-menu :menu="item.child" :isChild="true" :icon-expand="iconExpand"></z-menu>
        </div>
      </w-transition-slide-fade>
    </template>
  </template>
</template>

<script>
export default {
  name: 'ZMenu',
  props: {
    menu: [Array, Object],
    isChild: {
      type: Boolean,
      default: false,
    },
    iconExpand: {
      type: String,
      default: 'fal fa-angle-double-up'
    }
  },
  data: () => ({
    loaded: false,
  }),
  methods: {
    expand(item) {
      this.loaded = true
      item.isVisible = !(item.isVisible ?? false)
    },
    findCurrent(items) {
      if( Array.isArray(items) ) {
        items.filter(x => this.$page.url.startsWith(x.route)).forEach(y => y.isVisible = true)
        if(items.child) {
          this.findCurrent(items.child)
        }
      } else {
        // if the array if filtered, i.e. the key is not in sequence, es6 does not detect it as array and thus .filter can't be used
        Object.keys(items).forEach(i => {
          let item = items[i]
          if(this.$page.url.startsWith(item.route)) {
            item.isVisible = true
          }
      });
      }

      
    }
  },
  mounted() {
    // this.loaded = true
    // || (!loaded && $page.url.startsWith(item.route))
    this.findCurrent(this.menu)

  }
}
</script>

<style>
.menu-expanded {
  transform: rotate(0deg);
  -webkit-transition: -webkit-transform .2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  -ms-transition: -ms-transform .2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.menu-collapsed {
  transform: rotate(180deg);
  -webkit-transition: -webkit-transform .5s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  -ms-transition: -ms-transform .5s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.menu-item {
  border: 0px
}

.menu-has-child {
  /* font-weight: 700; */
}

.menu-is-child {
  background: linear-gradient(45deg, transparent, #171e44)
}

.menu-is-child a {
  /* border-left: azure solid 1px; */
  /* border-top-left-radius: 0px;
  border-bottom-left-radius: 0px; */
  margin-left: 10px;
  padding-left: 10px !important;
  padding-right: 12px !important;
}

.menu-is-child-has-child a {
  margin-left: 10px;
  padding-left: 10px !important;
  padding-right: 12px !important;
}

.menu-section-header {
  font-size: 8pt;
}
</style>